module.exports = __webpack_public_path__ + "static/img/bg.48469f55.png";